import React from 'react';

import { EmblaOptionsType } from 'embla-carousel';
import Fade from 'embla-carousel-fade';
import useEmblaCarousel from 'embla-carousel-react';

import { NextButton, PrevButton, usePrevNextButtons } from './embla-carousel-arrow-button';
import { DotButton, useDotButton } from './embla-carousel-dot-button';

import './embla.css';

import { cn } from '~/lib/utils';
import { getProductBySlug } from '~/services/api/products';

type PropType = {
  images: NonNullable<Awaited<ReturnType<typeof getProductBySlug>>>['images'];
  options?: EmblaOptionsType;
};

const ProductImageCarousel: React.FC<PropType> = (props) => {
  const { images, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Fade()]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {images.length > 0 ? (
            images.map((image, index) => (
              <div className="embla__slide" key={index}>
                <div className="embla__slide__wrapper">
                  <img
                    className="aspect-[4/3] w-full object-contain"
                    src={image.file.src}
                    alt={image.file.name}
                    loading="lazy"
                  />
                  <div className="embla__controls">
                    <div className="embla__buttons">
                      <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                      <div className="embla__dots">
                        {scrollSnaps.map((_, index) => (
                          <DotButton
                            key={index}
                            onClick={() => onDotButtonClick(index)}
                            className={cn('embla__dot', index === selectedIndex && 'embla__dot--selected')}
                          />
                        ))}
                      </div>
                      <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <img
              src={'/images/placeholder-image-600x400.png'}
              alt={'placeholder-image'}
              loading="lazy"
              className="aspect-[4/3] w-full object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductImageCarousel;
